import { environment } from 'config/environments';

export const isProd = environment === 'production';
export const isStaging = environment === 'staging';
export const isLocal = environment === 'local' || window.location.host.includes('localhost');
export const isTest = isStaging || isLocal;
